// src/components/layout/Header.jsx

import { DesktopHeader } from "./Desktop";
import { MobileHeader } from "./Mobile";
import { MobileMenu } from "./MobileMenu";
import { useHeaderState } from "../../../hooks/useHeaderState";
import { siteConfig } from "../../../content/config/global";
import { AnimatePresence } from "framer-motion";
import { globalConfig, getAllExperiences } from '@/content';

/**
 * Header
 * Renderiza el encabezado responsive, inyectando navegación dinámica para experiencias
 * desde la API de contenido centralizada (globalConfig + getAllExperiences).
 */
export const Header = ({ id, data }) => {
  const experiences = getAllExperiences();
  
  const headerProps = {
    ...globalConfig.header,
    ...data,
  };

  // Crear dropdown dinámico de experiencias
  const experiencesDropdown = {
    label: "Experiencias",
    show: "true",
    items: [
      {
        id: "all",
        label: "TODAS LAS EXPERIENCIAS",
        href: "/experiencias",
        description: "Explora todas nuestras aventuras VR"
      },
      ...experiences.map(exp => ({
        id: exp.slug,
        label: exp.title.toUpperCase(),
        href: `/experiencias/${exp.slug}`,
        description: exp.subtitle,
        badge: exp.badge ? {
          type: exp.badge.toLowerCase() === 'nuevo' ? 'nuevo' : 
                exp.badge.toLowerCase() === 'tendencia' ? 'tendencia' : 
                exp.badge.toLowerCase() === 'popular' ? 'popular' :
                exp.badge.toLowerCase() === 'intenso' ? 'intenso' : 'default',
          text: exp.badge
        } : null
      }))
    ]
  };

  // Actualizar la navegación para incluir el dropdown dinámico
  const updatedNavigation = headerProps.navigation.map(item => {
    if (item.label === "EXPERIENCIAS") {
      return {
        ...item,
        experienciasDropdown: experiencesDropdown
      };
    }
    return item;
  });

  // Hook personalizado para manejar el estado
  const {
    mobileMenuOpen,
    setMobileMenuOpen,
    dropdownStates,
    toggleDropdown,
    closeAllDropdowns,
    handleExperienciasItemClick,
  } = useHeaderState();

  return (
    <>
      <header
        id={id}
        className={`
          header w-full z-50 sm:top-0 transition-all duration-300
          ${headerProps.sticky ? "sticky top-0" : ""}
          px-4 sm:px-6 md:px-8 lg:px-16 py-4
          overflow-visible
        `}
        style={{
          backgroundColor: headerProps.backgroundColor,
          fontFamily: "Sweet Sans, system-ui, sans-serif",
        }}
        onClick={closeAllDropdowns}
      >
        <div className="flex items-start lg:items-start justify-between max-w-8xl mx-auto overflow-visible">
          <DesktopHeader
            showLogo={headerProps.showLogo}
            locationButton={headerProps.locationButton}
            navigation={updatedNavigation}
            ctaButton={headerProps.ctaButton}
            dropdownStates={dropdownStates}
            toggleDropdown={toggleDropdown}
            handleExperienciasItemClick={handleExperienciasItemClick}
          />

          <MobileHeader
            mobileMenuOpen={mobileMenuOpen}
            setMobileMenuOpen={setMobileMenuOpen}
          />
        </div>
      </header>

      <AnimatePresence>
        {mobileMenuOpen && (
          <MobileMenu
            isOpen={mobileMenuOpen}
            onClose={() => setMobileMenuOpen(false)}
            locationButton={headerProps.locationButton}
            navigation={updatedNavigation}
            ctaButton={headerProps.ctaButton}
            experienciasDropdown={experiencesDropdown}
            dropdownStates={dropdownStates}
            toggleDropdown={toggleDropdown}
            handleExperienciasItemClick={handleExperienciasItemClick}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
